import { deleteOrdersOrderIdPaymentsPaymentId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderChargesSumQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargesSumQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import { getOrderPaymentListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useDeleteOrderPaymentMutation = (
	orderId: number,
	paymentId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(() =>
			deleteOrdersOrderIdPaymentsPaymentId(orderId, paymentId),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.deletePaymentError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.deletePaymentSuccess));
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentListQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderChargesSumQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentDetailQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderFeeQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
		},
	});
};
